import { useQuery } from 'react-query';
import ProjectsAPI from 'services/API/ProjectsAPI';
import { dedupeLandTitleChangeEvents } from 'utils/activity';

export const useProjectEvents = (projectSlug: string) => {
  return useQuery(
    ['get-project-events', projectSlug],
    async () => {
      const result = await ProjectsAPI.getProjectEvents(projectSlug);

      const data = result?.data;

      // Dedupe Land Title Change events by permitnum
      return dedupeLandTitleChangeEvents(data);
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
